import { render, staticRenderFns } from "./ReturnSalesListDetail.vue?vue&type=template&id=f6353420&scoped=true"
import script from "./ReturnSalesListDetail.vue?vue&type=script&lang=js"
export * from "./ReturnSalesListDetail.vue?vue&type=script&lang=js"
import style0 from "./ReturnSalesListDetail.vue?vue&type=style&index=0&id=f6353420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6353420",
  null
  
)

export default component.exports